import { Feature } from 'app/shared/services/app/application/feature.model';

export class CONFIG {
    static SUPPORT_SITE_URL: string = 'https://support.togglit.io/';
    static ANALYTICS_TRACKING_ID: string = 'UA-76466135-2';
    static VERSION_NUMBER: string = '2.3.9';
    static ENDPOINT_URL: string = 'https://staging.api.togglit.io/cms/';
    static DEFAULT_FIREBASE: any = {
      apiKey: "AIzaSyAXvfU5lM156InURvm4H2btdxJl0v22Tes",
      authDomain: "togglit-staging.firebaseapp.com",
      databaseURL: "https://togglit-staging.firebaseio.com",
      storageBucket: "togglit-staging.appspot.com"
    };
    static CONTENT_SCHEMA_VERSION: string = '1';
    static DEFAULT_FEATURES: Feature[] = [
        {display_name: 'Home Screen Pods', system_name: 'Pods', feature_properties: null, icon: 'oi oi-menu', selected: false},
        {display_name: 'Ads', system_name: 'Ads', feature_properties: null, icon: 'oi oi-bookmark', selected: false},
        {
            display_name: 'Push Notifications',
            system_name: 'Notifications',
            feature_properties: null,
            icon: 'oi oi-bell',
            selected: false
        },
        {
            display_name: 'Training',
            system_name: 'training',
            feature_properties: null,
            icon: 'oi oi-book',
            selected: false
        },
        // {
        //     display_name: 'Messages',
        //     system_name: 'Messages',
        //     feature_properties: null,
        //     icon: 'oi oi-chat',
        //     selected: false
        // },
        // {
        //     display_name: 'iBeacons',
        //     system_name: 'iBeacons',
        //     feature_properties: null,
        //     icon: 'oi oi-location',
        //     selected: false
        // }
    ];
}



// WEBPACK FOOTER //
// /app/src/app/config/config.ts